import {
  some as _some,
  omit as _omit,
  forEach as _forEach,
  has as _has,
  findIndex as _findIndex,
  map as _map,
  get as _get,
} from "lodash-es";
import { REHYDRATE } from "redux-persist/constants";

export function makeMigrationMiddleware() {
  const migrationDispatch = (next) => (action) => {
    const needsMigration =
      action.type === REHYDRATE &&
      _has(action, "payload.humans") &&
      _some(action.payload.humans, (h) => _has(h, "notes"));

    if (needsMigration) {
      console.log("migrating human notes to human comments");

      const humanComments = _get(action, "payload.humanComments", []);
      const newComments = [];

      _forEach(action.payload.humans, (h) => {
        if (!_has(h, "notes")) return;
        if (_findIndex(humanComments, { id: h.id }) >= 0) return;

        newComments.push({
          id: h.id,
          humanId: h.id,
          text: h.notes,
          createdAt: h.modifiedAt,
          modifiedAt: h.modifiedAt,
          syncedAt: h.syncedAt,
          modified: h.modified || h.pending,
        });
      });

      console.log("added new human comments", newComments.length, newComments);

      action.payload.humanComments = [...humanComments, ...newComments];
      action.payload.humans = _map(action.payload.humans, (h) =>
        _omit(h, ["notes"])
      );
    }

    return next(action);
  };

  return (next) => (reducer, initialState, enhancer) => {
    var store = next(reducer, initialState, enhancer);
    return {
      ...store,
      dispatch: migrationDispatch(store.dispatch),
    };
  };
}
